import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import {
  GetHrStaff180Repository,
  GetHrStaff180Response,
} from "features/hr/data/repository/hr-appraisal.repository";
import { RootState } from "features/config/store";
import { HrStaff180Model } from "features/hr/core/domain/hr-staff-180.model";

export enum GetHrStaff180State {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetHrStaff180State;
  message: string;
  data: Array<HrStaff180Model> | undefined;
}

let initialState: InitialState = {
  status: GetHrStaff180State.initial,
  message: "",
  data: undefined,
};

export const getHrStaff180 = createAsyncThunk(
  "getHrStaff180",
  async (param, { rejectWithValue }) => {
    try {
      const response: GetHrStaff180Response = await GetHrStaff180Repository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getHrStaff180Slice = createSlice({
  name: "getHrStaff180",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHrStaff180.pending, (state) => {
        state.status = GetHrStaff180State.inProgress;
      })
      .addCase(getHrStaff180.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetHrStaff180State.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getHrStaff180.rejected, (state, action) => {
        state.status = GetHrStaff180State.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetHrStaff180 = (state: RootState) => state.getHrStaff180;

export default getHrStaff180Slice.reducer;
